import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import EventsListContainer from '../containers/events_list_container';
import RoundSelectorContainer from '../containers/round_selector_container';
import ScoringStatusContainer from '../containers/scoring_status_container';
import HeaderActionsContainer from '../containers/header_actions_container';
import Lbv2ToastContainer from '../containers/lbv2_toast_container';
import useViewMode from '../hooks/useViewMode';
import useEmbedHostClass from '../hooks/useEmbedHostClass';
import { VIEW_MODES } from '../constants';
import { isMobileSurface } from '../utils/device_utils';

const LeaderboardV2 = ({
  roundList, fetchLeaderboard, clearAll, isManagerSite, maybeShowRotateHint, markRotateHintUsed,
}) => {
  const viewMode = useViewMode();

  // Lets the portal page around our iframe widen for a landscape phone.
  useEmbedHostClass();

  useEffect(() => {
    fetchLeaderboard(viewMode);
  }, [fetchLeaderboard, viewMode]);

  // The coach mark greets the user on a portrait phone instead of waiting for a
  // tap on the rotate button. Reaching landscape is proof they found the
  // feature, so it retires the hint for good.
  useEffect(() => {
    if (!isMobileSurface()) {
      return;
    }

    if (viewMode === VIEW_MODES.LANDSCAPE) {
      markRotateHintUsed();
    } else if (viewMode === VIEW_MODES.MOBILE) {
      maybeShowRotateHint();
    }
  }, [viewMode, maybeShowRotateHint, markRotateHintUsed]);

  // Unmount-only cleanup. Keeping it out of the effect above is what makes
  // view-mode transitions seamless: the event slice survives, so
  // fetchLeaderboard's CASE 2 finds the open event and skips the refetch.
  useEffect(() => () => clearAll(), [clearAll]);

  return (
    <div id="lbv2__leaderboard">
      {isManagerSite && <ScoringStatusContainer />}
      {viewMode === VIEW_MODES.WEB && !isManagerSite && (
        <div className="lbv2__top-bar">
          {roundList.length > 1 && <RoundSelectorContainer viewMode={viewMode} refreshRoundsOnOpen />}
          <HeaderActionsContainer viewMode={viewMode} />
        </div>
      )}
      {/* Portals itself into the top document — it only measures against the
          leaderboard, so where it sits in this tree does not matter. */}
      <Lbv2ToastContainer />
      <EventsListContainer viewMode={viewMode} />
    </div>
  );
};

LeaderboardV2.propTypes = {
  roundList: PropTypes.array,
  fetchLeaderboard: PropTypes.func.isRequired,
  clearAll: PropTypes.func.isRequired,
  isManagerSite: PropTypes.bool,
  maybeShowRotateHint: PropTypes.func.isRequired,
  markRotateHintUsed: PropTypes.func.isRequired,
};

export default LeaderboardV2;
